module.exports = {
  anonymous: { api: 'anonymous', human: 'Anonym' },
  customer: { api: 'customer', human: 'Kunde' },
  makler: { api: 'makler', human: 'Makler' },
  mitarbeiter: { api: 'mitarbeiter', human: 'Mitarbeiter' },
  admin: { api: 'admin', human: 'Administrator' },
  developer: { api: 'developer', human: 'Entwickler' }
}
